export const CHAT_MEDIA_RETURN_TYPE = {
	IMAGE: 'image',
	VIDEO: 'video',
	TEXT: 'text',
};

export const CONVERSATION_STATS_SOURCE = {
	CHAT: 'CHAT',
	CALL_MODE: 'CALL_MODE',
};

export const MAX_CHAT_MESSAGE_LENGTH = 1000;

export const limitChatMessageLength = (value) => {
	if (typeof value !== 'string') {
		return '';
	}

	return value.slice(0, MAX_CHAT_MESSAGE_LENGTH);
};
